import React, { useContext } from 'react';
import { LinkProps, useLocation } from 'react-router-dom';

import { PagesFragment, PagesQuery, DressCodeItemsFragment } from '../../../generated/graphql';
import { TrackingContext } from '../../../TrackingContext';
import { Link } from '../../Link';
import { getDressCodeTrackingProperties } from './constants';

export type PageItem = NonNullable<PagesFragment['items']>[0];

interface DressCodePageItemLinkProps extends LinkProps {
  page: PagesQuery['pages'][0];
  pageItem: DressCodeItemsFragment;
  'data-testid'?: string;
}

export const DressCodePageItemLink: React.FC<DressCodePageItemLinkProps> = ({ page, pageItem, ...props }) => {
  const { track } = useContext(TrackingContext);
  const { pathname } = useLocation();

  const source = pathname.includes('preview') ? 'preview' : 'dashboard';

  const handleClick = () => {
    track('Item Action Initiated', {
      action: 'edit',
      actionName: 'Edit Page Item',
      page: page.title,
      item: 'DressCodeItem',
      source,
      ...getDressCodeTrackingProperties(pageItem),
    });
  };

  return <Link {...props} data-testid={props['data-testid'] || 'pageItemLink'} onClick={handleClick} />;
};

export default DressCodePageItemLink;
